import React from 'react';
import { Facebook, Twitter, Linkedin, Link as LinkIcon, Mail } from 'lucide-react';
export function ShareBar() {
  return <div className="flex items-center gap-2 py-4 border-y border-gray-200 my-6" data-id="element-60">
      <span className="text-xs font-bold uppercase tracking-wider text-gray-500 mr-2" data-id="element-61">
        Share
      </span>
      <button className="p-2 bg-[#1877F2] text-white rounded-sm hover:opacity-90 transition-opacity" aria-label="Share on Facebook" data-id="element-62">
        <Facebook size={16} fill="currentColor" data-id="element-63" />
      </button>
      <button className="p-2 bg-[#1DA1F2] text-white rounded-sm hover:opacity-90 transition-opacity" aria-label="Share on Twitter" data-id="element-64">
        <Twitter size={16} fill="currentColor" data-id="element-65" />
      </button>
      <button className="p-2 bg-[#BD081C] text-white rounded-sm hover:opacity-90 transition-opacity" aria-label="Share on Pinterest" data-id="element-66">
        <span className="font-bold font-serif text-sm leading-none px-0.5" data-id="element-67">
          P
        </span>
      </button>
      <button className="p-2 bg-gray-600 text-white rounded-sm hover:opacity-90 transition-opacity" aria-label="Email" data-id="element-68">
        <Mail size={16} data-id="element-69" />
      </button>
    </div>;
}